import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import styles from "./Test.module.css";
import styles from "./TestPerformance.module.css";
import { Link } from "react-router-dom";
import { Chip, Paper, styled } from "@mui/material";
import { AddCircleRounded, RemoveCircleRounded } from "@mui/icons-material";
import DatePickerSample from "../../DatePicker";
import IconButton from "@mui/material/IconButton";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../labels";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";

function TestPerformance({
  isLoading,
  setIsLoading,
  onSort,
  initialfields,
  handleChange,
  reportData,
  reportData1,
  handleFilterSearch,
  eeventName,
  setSelectedEvent,
  selectedEvent,
  handleCheckboxChange,
  updateChipData,
  handleApplyFilter,
  selectedSubject,
  setselectedStatus,
  selectedStatus,
  subject,
  setSelectedSubject,
  selectedToppics,
  testTopics,
  settestTopics,
  dateFilter,
  handleDateFilterChange,
  setIsopen,
  isOpen,
  setAppData,
  appData,
  handleDelete,
  handleClear,
  handleAppliedOn,
  handleChangeDate,
  setAppOn, // Keep only one instance of setAppOn
  appOn,
  batchId,
  batchType,
  activeTab,
  handleView,
  searchTerm,
  setSearchTerm,
  handleSearch,
}) {
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);

  const [expandedId, setExpandedId] = useState(null);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };
  let page = R_PER_PAGE;
  const [ranges, setRanges] = useState([30, 60]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const handleFilter = (e, filterKey) => {
    setIsopen((prev) => ({
      ...prev,
      [filterKey]: !prev[filterKey],
    }));
  };

  const generateCSVData = () => {
    const headers = [
      "S.No",
      "Event Name",
      "Date",
      "Subject",
      "Test Topic",
      "Number of Questions",
      "Total Marks",
      "Cut-off",
      "Obtained Marks",
      "Class Rank",
      "Overall Rank",
      "Status",
    ];

    const rows = [];
    let serialNumber = 1;

    currentData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name || "",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "",
          item.subject?.map((subj) => subj.subject).join(", ") || "",
          item.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
          item.no_of_questions ?? "",
          item.tot_marks ?? "",
          item.cut_off ?? "",
          item.marks_obtained !== null && item.marks_obtained !== undefined
            ? item.marks_obtained
            : "",
          item.event_rank !== null && item.event_rank !== undefined
            ? item.event_rank
            : "",
          item.over_all_event_rank ?? "",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent row for combined exam
        rows.push([
          serialNumber++,
          item.exam_name || "",
          "", // No date for parent
          "", // No subject for parent
          "", // No test topic for parent
          "", // No questions for parent
          item.tot_marks ?? "",
          item.cut_off ?? "",
          item.marks_obtained !== null && item.marks_obtained !== undefined
            ? item.marks_obtained
            : "",
          "", // No class rank for parent
          "", // No overall rank for parent
          "", // No status for parent
        ]);

        // Add child rows for each exam in the combined exam
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // Empty serial number for child rows
            child.event_name || "",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "",
            child.subject?.map((subj) => subj.subject).join(", ") || "",
            child.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
            child.no_of_questions ?? "",
            child.tot_marks ?? "",
            child.cut_off ?? "",
            child.marks_obtained !== null && item.marks_obtained !== undefined
              ? child.marks_obtained
              : "",
            child.event_rank !== null && child.event_rank !== undefined
              ? child.event_rank
              : "",
            child.over_all_event_rank ?? "",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    return [headers, ...rows];
  };
  // setIsLoading(true);
  //  setTimeout(() => {
  //               // setIsLoading(false);
  //               const content = contentRef.current;
  //               const options = {
  //                 margin: [0, 0, 0, 0],
  //                 filename:  "Test.pdf",
  //                 image: { type: "jpeg", quality: 1 },
  //                 html2canvas: { width: 2480, scale: 1, dpi: 300 },
  //                 jsPDF: { unit: "pt", format: "A4", orientation: "landscape" },
  //               };
  //               html2pdf().from(content.innerHTML).set(options).save();
  //               // return;
  //             }, 1000);
  // const contentRef = useRef();

  const generatePDF = () => {
    const headers = [
      "S.No",
      "Event Name",
      "Date",
      "Subject",
      "Test Topic",
      "Number of Questions",
      "Total Marks",
      "Cut-off",
      "Obtained Marks",
      "Class Rank",
      "Overall Rank",
      "Status",
    ];

    let serialNumber = 1;
    const rows = [];

    mergedData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name ?? "-",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "-",
          Array.isArray(item.subject)
            ? item.subject.map((s) => s.subject).join(", ")
            : "-",
          Array.isArray(item.test_topic)
            ? item.test_topic.map((t) => t.test_topic).join(", ")
            : "-",
          item.no_of_questions ?? "-",
          item.tot_marks ?? "-",
          item.cut_off ?? "-",
          item.marks_obtained ?? "-",
          item.event_rank ?? "-",
          item.over_all_event_rank ?? "-",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent combined exam row
        rows.push([
          serialNumber++,
          item.exam_name ?? "-",
          "-",
          "-",
          "-",
          "-", // skip fields for combined header
          item.tot_marks ?? "-",
          item.cut_off ?? "-",
          item.marks_obtained ?? "-",
          "-",
          "-",
          "-", // skip ranks and status
        ]);

        // Add child exams
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // no serial for child
            child.event_name ?? "-",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "-",
            Array.isArray(child.subject)
              ? child.subject.map((s) => s.subject).join(", ")
              : "-",
            Array.isArray(child.test_topic)
              ? child.test_topic.map((t) => t.test_topic).join(", ")
              : "-",
            child.no_of_questions ?? "-",
            child.tot_marks ?? "-",
            child.cut_off ?? "-",
            child.marks_obtained ?? "-",
            child.event_rank ?? "-",
            child.over_all_event_rank ?? "-",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    // Navigate to preview page with table structure
    navigate("/preview", {
      state: {
        title: "Test Performance Data",
        headers,
        rows,
        filename: "TestPerformance.pdf",
        autoPrint: true,
      },
    });
  };

  const filterEventNameRef = useRef(null);
  const filterDateRef = useRef(null);
  const filterSubjectRef = useRef(null);
  const filterStatusRef = useRef(null);
  const filterTotalMarksRef = useRef(null);

  // Combine both arrays safely
  const combinedData = [
    ...(Array.isArray(reportData) ? reportData : []),
    ...(Array.isArray(reportData1) ? reportData1 : []),
  ];

  const mergedData = [...reportData, ...reportData1];
  const totalRecords = mergedData.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = mergedData.slice(start, end);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterEventNameRef.current &&
        !filterEventNameRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasEventName = updateChipData.some(
          (chipItem) => chipItem.type === "eventName"
        );

        if (hasEventName) {
          const updatedEventName = updateChipData.filter(
            (chipItem) => chipItem.type === "eventName"
          );
          setSelectedEvent(updatedEventName);
        } else {
          setSelectedEvent([]);
        }

        setIsopen((prev) => ({ ...prev, eventName: false }));
      }

      if (
        filterDateRef.current &&
        !filterDateRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker") &&
        !event.target.closest(".filterBoxOne_Con")
      ) {
        const dateChip = updateChipData.find(
          (chipItem) =>
            chipItem.type === "dayRange" || chipItem.type === "dateRange"
        );

        if (dateChip) {
          if (dateChip.type === "dayRange") {
            setAppData({
              FDate: "",
              TDate: "",
              Days: dateChip.Days,
              name: "",
            });
          } else {
            setAppData({
              FDate: dateChip.fdate,
              TDate: dateChip.edate,
              Days: "",
              name: "",
            });
          }
          setAppOn([dateChip]);
        } else {
          setAppData({
            FDate: "",
            TDate: "",
            Days: "",
            name: "",
          });
          setAppOn([]);
        }

        setIsopen((prev) => ({ ...prev, appliedOn: false }));
      }

      if (
        filterSubjectRef.current &&
        !filterSubjectRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasSubject = updateChipData.some(
          (chipItem) => chipItem.type === "subject"
        );

        if (hasSubject) {
          const updatedSubject = updateChipData.filter(
            (chipItem) => chipItem.type === "subject"
          );
          setSelectedSubject(updatedSubject);
        } else {
          setSelectedSubject([]);
        }

        setIsopen((prev) => ({ ...prev, subject: false }));
      }

      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setselectedStatus(updatedStatus);
        } else {
          setselectedStatus([]);
        }

        setIsopen((prev) => ({ ...prev, status: false }));
      }

      if (
        filterTotalMarksRef.current &&
        !filterTotalMarksRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        setIsopen((prev) => ({ ...prev, tot_marks: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);
  return (
    <div className={`container-fluid  global_container BathDet p-0`}>
      <div className="row ">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
          <div class="input-group">
            <input
              //   ref={txtBSearch}
              type="text"
              class={styles.Inputs}
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Event Names, Subject, Test Topics"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
            <span
              class={styles.input_group_text}
              id="SearchInput"
              onClick={handleSearch}
            >
              <span className="material-icons" onClick={handleSearch}>
                search
              </span>
            </span>
          </div>
        </div>

        {/* <div className="col-md-8 col-12 ListBtn">
          <ul className="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={generateCSVData()}
                iconName=" file_download "
                filename={"TestPerfomance.csv"}
                csvName="Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div> */}
      </div>
      {updateChipData.length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                let key = "" + data.name;
                return (
                  <ListItem key={data}>
                    <Chip
                      icon={icon}
                      label={key}
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}

              <ListItem>
                <a
                  className="clearAll_listItem"
                  href="#"
                  onClick={() => handleClear("all")}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th" className={styles.headspace}>
                  <span
                    onClick={() => onSort("event_name")}
                    className="textHead_th"
                  >
                    Event Name
                  </span>
                  <span
                    onClick={() => onSort("event_name")}
                    className="textHead_th material-icons align-middle"
                    style={{ cursor: "pointer" }}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "eventName")}
                    className={`align-middle material-icons color-table ${
                      selectedEvent.length > 0 || isOpen.eventName
                        ? styles.active_icons_book
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    filter_list
                  </span>

                  {isOpen.eventName && (
                    <div
                      ref={filterEventNameRef}
                      className={styles.filterBoxs_testlist}
                      style={{ left: "5px" }}
                    >
                      <div className="col-md-12 form-check filterStatus_list">
                        {/* Search Input with Icon Inside */}
                        <div className="input-group">
                          <div style={{ position: "relative", width: "100%" }}>
                            <input
                              type="text"
                              className={styles.Inputsearch}
                              id="SearchInput"
                              name="SearchInput"
                              // value={searchGroupName}
                              placeholder="Search by Event Name"
                              onChange={(e) =>
                                handleFilterSearch(e, "eventName")
                              }
                            />
                            <span
                              className={`material-icons ${styles.materialicons}`}
                            >
                              search
                            </span>
                          </div>
                        </div>

                        {/* List of Event Filters */}
                        <ul className="ulFilterListData">
                          {eeventName.map((el) => (
                            <li className="filterListData" key={el.event_pk}>
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={el.event_name}
                                value={el.event_pk}
                                id={`event-${el.event_pk}`}
                                checked={selectedEvent.some(
                                  (element) => element.id == el.event_pk
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "eventName")
                                }
                              />
                              <label
                                className="form-check-label "
                                style={{ padding: "5px" }}
                                htmlFor={`event-${el.event_pk}`}
                              >
                                {el.event_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Clear and Apply Filter Buttons */}
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("eventName")}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("eventName")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  <span
                    onClick={() => onSort("start_date")}
                    className="textHead_th px-1"
                  >
                    Date
                  </span>
                  <span
                    onClick={() => onSort("start_date")}
                    className={`material-icons textHead_th align-middle`}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilter(e, "appliedOn");
                    }}
                    className={` textHead_th align-middle material-icons ${
                      (appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.appliedOn
                        ? styles.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>

                  {isOpen.appliedOn === true && (
                    <div
                      className="filterBoxs_testlist mt-2 p-2"
                      ref={filterDateRef}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        left: "10px",
                      }}
                    >
                      <div className="form-check p-1">
                        <label
                          htmlFor="startDate"
                          className="form-label confirm_value me-1"
                        >
                          From Date
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="FDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.FDate}
                          txtAdMDob={fDatePickerRef}
                        />
                      </div>

                      <div className="form-check p-1 mt-2">
                        <label
                          htmlFor="endDate"
                          className="form-label confirm_value me-1"
                        >
                          To Date{" "}
                          <span data-required="true" aria-hidden="true"></span>
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="TDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.TDate}
                          txtAdMDob={tDatePickerRef}
                          minDate={appData.FDate}
                        />
                      </div>

                      <div className="row mt-3">
                        {[
                          { id: "Today", label: "Today" },
                          { id: "Yesterday", label: "Yesterday" },
                          { id: "Tweek", label: "This Week" },
                          { id: "Lweek", label: "Last Week" },
                          { id: "Tmonth", label: "This Month" },
                          { id: "Lmonth", label: "Last Month" },
                        ].map(({ id, label }) => (
                          <div key={id} className="col-md-6 col-6">
                            <div className="form-check">
                              <input
                                type="radio"
                                className="form-check-input"
                                id={id}
                                name="Days"
                                value={id}
                                checked={appData.Days === id}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label d-flex"
                                htmlFor={id}
                                style={{ fontWeight: "bold" }}
                              >
                                {label}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("startDate")}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("startDate")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {/* <div className="borderWidth row row mt-2">
                        <div className="col-md-4 col-4">
                          <span
                            className="clearFilter ms-2"
                            onClick={() => handleClear("startDate")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8 col-8 text-end">
                          <button
                            className="primaryButton"
                            onClick={handleApplyFilter}
                          >
                            Apply Filter2
                          </button>
                        </div>
                      </div> */}
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("subject")}
                    className="textHead_th"
                  >
                    Subject
                  </span>
                  <span
                    onClick={() => onSort("subject")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                  {/* <span
                    onClick={(e) => handleFilter(e, "subject")}
                    className={`align-middle material-icons color-table ${
                      selectedSubject.length > 0 || isOpen.subject
                        ? styles.active_icons_book
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    filter_list
                  </span>
                  {isOpen.subject && (
                    <div
                      ref={filterSubjectRef}
                      className={styles.filterBoxs_testlist}
                      style={{ left: "5px" }}
                    >
                      <div className="col-md-12 form-check filterStatus_list">
                        <div className="input-group">
                          <div style={{ position: "relative", width: "100%" }}>
                            <input
                              type="text"
                              className={styles.Inputsearch}
                              id="SearchSubjectInput"
                              name="SearchSubjectInput"
                              placeholder="Search by Subject"
                              onChange={(e) => handleFilterSearch(e, "subject")}
                            />
                            <span
                              className={`material-icons ${styles.materialicons}`}
                            >
                              search
                            </span>
                          </div>
                        </div>

                        <ul className="ulFilterListData">
                          {subject.map((subj, idx) => (
                            <li className="filterListData" key={idx}>
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={subj.subject}
                                value={subj.subject_pk}
                                id={`subject-${idx}`}
                                checked={selectedSubject.some(
                                  (element) => element.id == subj.subject_pk
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "subject")
                                }
                              />
                              <label
                                className={`form-check-label ${styles.labelSubject}`}
                                htmlFor={`subject-${idx}`}
                              >
                                {subj.subject}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <button
                              type="button"
                              onClick={() => handleClear("subject")}
                              className="secondaryButton ms-2"
                              style={{ border: "none", background: "none" }}
                            >
                              Clear
                            </button>
                          </li>
                          <li className="ListBtnItems">
                            <button
                              type="button"
                              onClick={() => handleApplyFilter("subject")}
                              className="primaryButton"
                            >
                              Apply Filter3
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )} */}
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("test_topic")}
                    className="textHead_th"
                  >
                    Test Topic
                  </span>
                  <span
                    onClick={() => onSort("test_topic")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("no_of_questions")}
                    className="textHead_th"
                  >
                    Number of Questions
                  </span>
                  <span
                    onClick={() => onSort("no_of_questions")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    className="textHead_th"
                    onClick={() => onSort("tot_marks")}
                  >
                    Total Marks
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={() => onSort("tot_marks")}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      initialfields.fromDate ||
                      initialfields.toDate ||
                      isOpen.tot_marks
                        ? styles.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "tot_marks")}
                  >
                    filter_list
                  </span>
                  {isOpen.tot_marks === true && (
                    <div
                      ref={filterTotalMarksRef}
                      className={styles.filterBoxs}
                    >
                      <div className="row ">
                        <div className="col-md-12">
                          <div>
                            <div>
                              <label
                                for="bookName"
                                class="form-label confirm_value "
                              >
                                From
                              </label>
                            </div>
                            <input
                              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                              type="number"
                              id="fromDate"
                              name="fromDate"
                              maxLength={50}
                              placeholder="Enter the Min Marks"
                              value={initialfields.fromDate}
                              onChange={handleChange}
                            />
                          </div>
                          <div>
                            <div>
                              <label
                                for="bookName"
                                class="form-label confirm_value "
                              >
                                To
                              </label>
                            </div>
                            <input
                              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                              type="number"
                              id="toDate"
                              name="toDate"
                              min={0}
                              max={1000}
                              placeholder="Enter the Max  Marks"
                              value={initialfields.toDate}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="borderWidth row mt-3">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("tot_marks")}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("tot_marks")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {/* <hr style={{ margin: "0rem" }} />
                      <div className="borderWidth row mt-3">
                        <div className="List-Button col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("tot_marks")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="primaryButton"
                            onClick={() => handleApplyFilter("tot_marks")}
                          >
                            Apply Filter4
                          </button>
                        </div>
                      </div> */}
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("cut_off")}
                    className="textHead_th"
                  >
                    Cut-off
                  </span>
                  <span
                    onClick={() => onSort("cut_off")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("marks_obtained")}
                    className="textHead_th"
                  >
                    obtained Marks
                  </span>
                  <span
                    onClick={() => onSort("marks_obtained")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("event_rank")}
                    className="textHead_th"
                  >
                    Class Rank
                  </span>
                  <span
                    onClick={() => onSort("event_rank")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("over_all_event_rank")}
                    className="textHead_th"
                  >
                    Overall Rank
                  </span>
                  <span
                    onClick={() => onSort("over_all_event_rank")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => onSort("status")}
                    className="textHead_th"
                  >
                    Status
                  </span>
                  <span
                    onClick={() => onSort("status")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                  <span
                    className={`align-middle material-icons color-table ${
                      selectedStatus.length > 0 || isOpen.status
                        ? styles.active_icons_book
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>

                  {isOpen.status === true && (
                    <div
                      className="filterBoxs_testlist mt-2"
                      ref={filterStatusRef}
                    >
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Absent"
                              value="0"
                              id="Absent"
                              checked={selectedStatus.some(
                                (el) => el.id === "0"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    { id: "0", name: "Absent", type: "status" },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label filterChipText bg-green"
                              htmlFor="Absent"
                            >
                              Absent
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Completed"
                              value="1"
                              id="Completed"
                              checked={selectedStatus.some(
                                (el) => el.id === "1"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    {
                                      id: "1",
                                      name: "Completed",
                                      type: "status",
                                    },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label bg-orange filterChipText"
                              htmlFor="Completed"
                            >
                              Completed
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => {
                                setselectedStatus([]);
                                handleClear("status");
                              }}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => {
                                handleApplyFilter();
                                setIsopen({ ...isOpen, status: false });
                              }}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {/* <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <button
                              style={{ border: "none", background: "none" }}
                              type="button"
                              onClick={() => {
                                setselectedStatus([]);
                                handleClear("status");
                              }}
                              className="secondaryButton"
                            >
                              Clear
                            </button>
                          </li>
                          <li className="ListBtnItems">
                            <button
                              type="button"
                              onClick={() => {
                                handleApplyFilter();
                                setIsopen({ ...isOpen, status: false });
                              }}
                              className="primaryButton"
                            >
                              Apply Filter5
                            </button>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  )}
                </th>
                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData.map((item, index) =>
                  item.type === "single_exam" ? (
                    <tr key={index}>
                      <td id="td" style={{ paddingLeft: "48px" }}>
                        <span
                          className={styles.ellipsisText}
                          title={item.event_name}
                        >
                          {item.event_name}
                        </span>
                      </td>
                      <td id="td">
                        <span title={item.start_date}>
                          {new Date(item.start_date).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </span>
                      </td>
                      <td id="td">
                        <span
                          className={styles.ellipsisText}
                          title={item.subject
                            ?.map((subject) => subject.subject)
                            .join(", ")}
                        >
                          {item.subject
                            ?.map((subject) => subject.subject)
                            .join(", ")}
                        </span>
                      </td>
                      <td id="td">
                        <span
                          className={styles.ellipsisText}
                          title={item.test_topic
                            ?.map((topic) => topic.test_topic)
                            .join(", ")}
                        >
                          {item.test_topic
                            ?.map((topic) => topic.test_topic)
                            .join(", ")}
                        </span>
                      </td>
                      <td id="td">
                        <span>{item.no_of_questions}</span>
                      </td>
                      <td id="td">
                        <span>{item.tot_marks}</span>
                      </td>
                      <td id="td">
                        <span>{item.cut_off}</span>
                      </td>
                      <td id="td">
                        <span>{item.marks_obtained}</span>
                      </td>
                      <td id="td">
                        <span>{item.event_rank}</span>
                      </td>
                      <td id="td">
                        <span>{item.over_all_event_rank}</span>
                      </td>
                      <td id="td">
                        <span
                          className={`filterChipText ${
                            item.status === 1 ? "bg-orange" : "bg-green"
                          }`}
                          title={item.status === 1 ? "Completed" : "Absent"}
                        >
                          {item.status === 1 ? "Completed" : "Absent"}
                        </span>
                      </td>
                      <td id="td">
                        <button className="view_icon_button">
                          <span
                            className="visibleicon material-icons"
                            onClick={() =>
                              handleView(
                                item.event_pk,
                                item.batch_id,
                                0,
                                item.event_type,
                                item.type
                              )
                            }
                          >
                            visibility
                          </span>
                        </button>
                      </td>
                    </tr>
                  ) : item.type === "combined_exam" ? (
                    <React.Fragment key={index}>
                      {/* Parent Row */}
                      <tr
                        onClick={() => toggleExpand(item.exam_name)}
                        style={{ cursor: "pointer" }}
                      >
                        <td id="td">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <IconButton
                              size="medium"
                              disableRipple
                              style={{
                                color: "#808080",
                                padding: "6px",
                                marginRight: "6px",
                              }}
                            >
                              {expandedId === item.exam_name ? (
                                <RemoveCircleRounded fontSize="medium" />
                              ) : (
                                <AddCircleRounded fontSize="medium" />
                              )}
                            </IconButton>
                            <span title={item.exam_name}>{item.exam_name}</span>
                          </div>
                        </td>
                        <td>{/* DATE */}</td>
                        <td>{/* SUBJECT */}</td>
                        <td>{/* TOPIC */}</td>
                        <td>{/* NO OF QUESTIONS */}</td>
                        <td id="td">
                          <span>{item.tot_marks}</span>
                        </td>
                        <td id="td">
                          <span>{item.cut_off}</span>
                        </td>
                        <td id="td">
                          <span>{item.marks_obtained}</span>
                        </td>
                        <td>{/* CLASS RANK */}</td>
                        <td>{/* OVER ALL RANK */}</td>
                        <td>{/* STATUS */}</td>
                        <td>{/* ACTION */}</td>
                      </tr>

                      {/* Child Rows */}
                      {expandedId === item.exam_name &&
                        item.exam_data?.map((child, i) => (
                          <tr key={`child-${i}`}>
                            <td id="td">
                              <span
                                style={{
                                  paddingLeft: "48px",
                                  display: "inline-block",
                                }}
                              >
                                {child.event_name}
                              </span>
                            </td>
                            <td id="td">
                              <span title={child.start_date}>
                                {new Date(child.start_date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}
                              </span>
                            </td>

                            <td id="td">
                              <span
                                className={styles.ellipsisText}
                                title={child.subject
                                  ?.map((subject) => subject.subject)
                                  .join(", ")}
                              >
                                {child.subject
                                  ?.map((subject) => subject.subject)
                                  .join(", ")}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                className={styles.ellipsisText}
                                title={child.test_topic
                                  ?.map((topic) => topic.test_topic)
                                  .join(", ")}
                              >
                                {child.test_topic
                                  ?.map((topic) => topic.test_topic)
                                  .join(", ")}
                              </span>
                            </td>
                            <td id="td">
                              <span>{child.no_of_questions}</span>
                            </td>
                            <td id="td">
                              <span>{child.tot_marks}</span>
                            </td>
                            <td id="td">
                              <span>{child.cut_off}</span>
                            </td>
                            <td id="td">
                              <span>{child.marks_obtained}</span>
                            </td>
                            <td id="td">
                              <span>{child.event_rank}</span>
                            </td>
                            <td id="td">
                              <span>{child.over_all_event_rank}</span>
                            </td>
                            <td id="td">
                              <span
                                className={`filterChipText ${
                                  child.status === 1 ? "bg-orange" : "bg-green"
                                }`}
                                title={
                                  child.status === 1 ? "Completed" : "Absent"
                                }
                              >
                                {child.status === 1 ? "Completed" : "Absent"}
                              </span>
                            </td>
                            <td id="td">
                              <button className="view_icon_button">
                                <span
                                  className="visibleicon material-icons"
                                  onClick={() =>
                                    handleView(
                                      child.event_pk,
                                      child.batch_id,
                                      0,
                                      child.event_type,
                                      child.type
                                    )
                                  }
                                >
                                  visibility
                                </span>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ) : null
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={totalRecords > 0 ? start + 1 : 0}
          endPage={totalRecords > 0 ? Math.min(end, totalRecords) : 0}
          totalRecords={totalRecords}
          handlePrev={() => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${styles.prev_button} ${styles.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages}
        />
      </div>
    </div>
  );
}

export default TestPerformance;
